import ReturnsRow from './ReturnsRow';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsRow);
